import React, { useContext, useEffect, useState } from "react";
import Close from "../../../../images/Close.svg";

import { Form, Formik, FormikProps } from "formik";

import { useLazyQuery, useMutation } from "@apollo/client";
import {
  AddEmpMasterResult,
  AddEmpMasterVar,
  EmpMaster,
  EmpMasterOrderField,
  EmpQueryType,
  UpdateEmpMasterResult,
  UpdateEmpMasterVar,
} from "./queries/types";

import { Title } from "../../../../stories/Title/Title";
import { empType, Operation } from "../../../../utils/Enum.types";
import { LabelProps } from "../../../../utils/types";
import { Label } from "../../../../stories/Label/Label";
import {
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../utils/constants";

import { AppContext } from "../../../../context/context";
import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import {
  handleFormEvent,
  handleMUISelectEvent,
  removeMoreSpace,
} from "../../../../utils/UtilFunctions";
import MessageModal from "../../../../customComponents/MessageModal";
import TextArea from "../../../../stories/TextArea/TextArea";
import InputNumber from "../../../common/Input/InputNumber";
import InputHoc from "../../../common/Input/Index";
import { Button } from "../../../../stories/Button/Button";
import { PredefinedDataTypes, UserFormType } from "../../../../utils/formTypes";
import { AddEmpMaster, UpdateEmpMaster } from "./queries/mutations";
import useUrlParams from "../../../../customHooks/useUrlParams";
import { userValidation } from "../../../../utils/validationSchema";
import { nodeVar, OrderDirection } from "../../../../utils/commonQueryTypes";
import { GetEmp, GetEmpMasterByNodeId } from "./queries/queries";
import { Keys } from "../../../../utils/Enum.keys";
import PhoneInput from "react-phone-input-2";
import LoadingModal from "../../../pages/LoadingModal";
import { modalOpertaionFlag } from "../../customer/Index";
import PredefinedSelect from "../../../../customComponents/PredefinedSelect";
import useFormJson from "../../../../json/useFormJson";
import EmpTypeSelect from "../../../../customComponents/EmpTypeSelect";
import CompaniesAutocomplete from "../../customer/companies/CompaniesAutocomplete";
import useLabels from "../../../../customHooks/useLabels";
import SubsidiarySelect from "../../../../customComponents/SubsidiarySelect";
import SiteSelect from "../../../../customComponents/SiteSelect";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<modalOpertaionFlag>>;
  operation: Operation;
}

const AddUsers = ({ setModalFlag, operation }: Props) => {
  const [message, setMessage] = useState(emptyMessage);
  const { state } = useContext(AppContext);
  const { userFormLabels } = useFormJson();
  const { customer_id } = useUrlParams();
  const emptyFormData: UserFormType = {
    address: "",
    email: "",
    name: "",
    designation: "",
    mobile: "",
    pin: "",
    place: "",
    state: "",
    empType: "",
    companyID: 0,
    kgid: 0,
    metalNo: 0,
    siteID: 0,
    subsidiaryID: 0,
  };

  const { companyLabel, subsidiaryLabel, subsidiarySiteLabel } = useLabels();

  const [formData, setFormData] = useState<UserFormType>(emptyFormData);
  const { user_details } = useLoggedInUserDetails();

  const [GetEmpById, { data, loading: GetEmpMasterByNodeIdLoading }] =
    useLazyQuery<{ node: EmpMaster }, nodeVar>(GetEmpMasterByNodeId);

  const [AddEmpDetails, { loading: AddEmpMasterLoading }] = useMutation<
    AddEmpMasterResult,
    AddEmpMasterVar
  >(AddEmpMaster, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [UpdateEmpDetails, { loading: UpdateEmpMasterLoading }] = useMutation<
    UpdateEmpMasterResult,
    UpdateEmpMasterVar
  >(UpdateEmpMaster, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<UserFormType>
  ) => {
    const { name, value } = e.target as HTMLInputElement;
    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };
  const handleSubmit = async () => {
    try {
      if (operation === Operation.CREATE) {
        if (customer_id) {
          const empAdded = AddEmpDetails({
            variables: {
              user_details,
              input: {
                address: removeMoreSpace(formData.address),
                place: removeMoreSpace(formData.place),
                email: formData.email,
                mobile:
                  formData.mobile.length === 12
                    ? `+${formData.mobile}`
                    : EMPTY_STRING,
                pin: formData.pin,
                state: formData.state,
                name: removeMoreSpace(formData.name),
                empType: formData.empType as empType,
                companyID: formData.companyID,
                kgid: Number(formData.kgid),
                metalNo: Number(formData.metalNo),
                siteID: formData.siteID,
                subsidiaryID: formData.subsidiaryID,
              },
              customer_id: customer_id,
            },
            refetchQueries: [
              {
                query: GetEmp,
                variables: {
                  after: null,
                  customer_id,
                  first: ROWS_PER_PAGE,
                  input: {
                    queryType: EmpQueryType.ALL,
                    empType: [empType.DCP],
                    companyID: state.companyId ? state.companyId : 0,
                    ldgrID: 0,
                    siteID: state.subSiteId ? state.subSiteId : 0,
                    subsidiaryID: state.subsidiaryId ? state.subsidiaryId : 0,
                  },
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: EmpMasterOrderField.NAME,
                  },
                  name: EMPTY_STRING,
                },
              },
            ],
          });
          const { data } = await empAdded;

          if (data && data.AddEmpMaster) {
            setMessage({
              flag: true,
              message: "Employee added successfully",
              operation: Operation.CREATE,
            });
          }
        }
      } else {
        const customerUpdated = UpdateEmpDetails({
          variables: {
            user_details,
            customer_id: state.customerId,
            emp_id: state.empId,
            input: {
              address: removeMoreSpace(formData.address),
              place: removeMoreSpace(formData.place),
              email: formData.email,
              mobile:
                formData.mobile.length === 12
                  ? `+${formData.mobile}`
                  : EMPTY_STRING,
              pin: formData.pin,
              state: formData.state,
              name: removeMoreSpace(formData.name),
              empType: formData.empType as empType,
              companyID: formData.companyID,
              kgid: Number(formData.kgid),
              metalNo: Number(formData.metalNo),
              siteID: formData.siteID,
              subsidiaryID: formData.subsidiaryID,
            },
          },
          refetchQueries: [
            {
              query: GetEmp,
              variables: {
                after: null,
                customer_id,
                input: {
                  queryType: EmpQueryType.ALL,
                  empType: [empType.DCP],
                  ldgrID: 0,
                  companyID: 0,
                  subsidiaryID: 0,
                  siteID: 0,
                },
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: EmpMasterOrderField.NAME,
                },
                name: EMPTY_STRING,
              },
            },
          ],
        });
        const { data } = await customerUpdated;

        if (data && data.UpdateEmpMaster) {
          setMessage({
            flag: true,
            message: "Employee details updated successfully",
            operation: Operation.CREATE,
          });
        }
      }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };

  const hanldeClear = () => {
    const inputElement = document.getElementsByName(
      "name"
    )[0] as HTMLInputElement;
    if (inputElement) inputElement.focus();

    setFormData(emptyFormData);
  };

  const handleClose = () => {
    setMessage(emptyMessage);
    if (message.operation !== Operation.NONE) {
      hanldeClear();
      setModalFlag({
        flag: false,
        operation: Operation.CREATE,
      });
    }
  };

  useEffect(() => {
    if (operation === Operation.UPDATE) {
      GetEmpById({
        variables: {
          id: state.empId,
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setFormData({
            address: data.node.address,
            email: data.node.email,
            name: data.node.name,
            designation: data.node.empType,

            mobile: data.node.mobile.replace("+", ""),
            pin: data.node.pin,
            place: data.node.place,
            state: data.node.state,
            empType: data.node.empType,
            companyID: data.node.companyID,
            kgid: data.node.kgid,
            metalNo: data.node.metalNo,
            siteID: data.node.siteID,
            subsidiaryID: data.node.subsidiaryID,
          });
        }
      });
    }
  }, [operation, GetEmpById, state.empId, data]);

  const handleNumberChange = (name: string, value: string) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <>
      <div className="cust_users__add--title">
        <Title>{operation === Operation.CREATE ? "Add" : "Update"} User</Title>
        <img
          src={Close}
          alt=""
          onClick={() => {
            hanldeClear();
            setModalFlag({
              flag: false,
              operation: Operation.CREATE,
            });
          }}
        />
      </div>
      <Formik
        initialValues={formData}
        validationSchema={userValidation}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <>
              <div className="customer__add">
                <Form className="customer__add--edit">
                  <div className="cust_users__add--form-head">
                    <h4>User Details</h4>
                  </div>
                  <div className="customer__add--form-details row g-0">
                    <div className="col h-100">
                      <div className="label-grid">
                        <Label>Employee type</Label>
                        <EmpTypeSelect
                          value={formData.empType}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              empType: e,
                            });
                          }}
                        />
                      </div>
                      {userFormLabels.leftForm.map(
                        (field: LabelProps, key: React.Key) => {
                          if (field.dataType === "textarea") {
                            return (
                              <div className="label-grid" key={key}>
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  type={field.dataType}
                                  rows={3}
                                  name={field.inputName}
                                />
                                {meta.touched &&
                                  meta.errors[field.inputName] ? (
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                ) : null}
                              </div>
                            );
                          } else if (field.dataType === "number") {
                            return (
                              <div className="label-grid" key={key}>
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  country={"in"}
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  onKeyDown={handleFormEvent}
                                  name={field.inputName}
                                  required={field.required}
                                  maxLength={field.maxLength}
                                />
                                {meta.touched &&
                                  meta.errors[field.inputName] ? (
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                ) : null}
                              </div>
                            );
                          } else if (field.inputName === "mobile") {
                            return (
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <PhoneInput
                                  country={"in"}
                                  value={formData[field.inputName] as string}
                                  onChange={(e: string) => {
                                    handleNumberChange(field.inputName, e);
                                  }}
                                  inputProps={{
                                    required: true,
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === Keys.ENTER) {
                                      e.preventDefault();
                                      handleMUISelectEvent(e);
                                    }
                                  }}
                                />
                              </div>
                            );
                          } else {
                            return (
                              <React.Fragment key={key}>
                                <InputHoc
                                  LabelName={field.labelName}
                                  values={formData[field.inputName]}
                                  name={field.inputName}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  required={field.required}
                                  autoFocus={field.autoFocus}
                                />
                                {meta.touched &&
                                  meta.errors[field.inputName] ? (
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                ) : null}
                              </React.Fragment>
                            );
                          }
                        }
                      )}
                    </div>
                    <div className="col h-100">
                      {userFormLabels.rightForm.map(
                        (field: LabelProps, key: React.Key) => {
                          if (field.dataType === "textarea") {
                            return (
                              <div className="label-grid" key={key}>
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  type={field.dataType}
                                  rows={3}
                                  name={field.inputName}
                                  required={field.required}
                                />
                                {meta.touched &&
                                  meta.errors[field.inputName] ? (
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                ) : null}
                              </div>
                            );
                          } else if (field.dataType === "state") {
                            return (
                              <div className="label-grid" key={key}>
                                <Label>{field.labelName}</Label>
                                <PredefinedSelect
                                  label=""
                                  onChange={(e, state_code) => {
                                    setFormData({
                                      ...formData,
                                      state: e,
                                      gstStateCode: state_code
                                        ? state_code
                                        : EMPTY_STRING,
                                    });
                                  }}
                                  type={PredefinedDataTypes.STATE}
                                  value={formData.state as string}
                                  name={field.inputName as string}
                                />
                              </div>
                            );
                          } else if (field.dataType === "city") {
                            return (
                              <div className="label-grid" key={key}>
                                <Label>{field.labelName}</Label>
                                <PredefinedSelect
                                  label=""
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      place: e,
                                    });
                                  }}
                                  type={PredefinedDataTypes.CITY}
                                  value={formData.place as string}
                                  name={field.inputName as string}
                                />
                              </div>
                            );
                          } else if (field.dataType === "mobile") {
                            return (
                              <div className="label-grid" key={key}>
                                <Label>{field.labelName}</Label>
                                <PhoneInput
                                  country={"in"}
                                  value={formData[field.inputName] as string}
                                  onChange={(e: string) => {
                                    handleNumberChange(field.inputName, e);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === Keys.ENTER) {
                                      e.preventDefault();
                                      handleMUISelectEvent(e);
                                    }
                                  }}
                                  inputProps={{
                                    required: true,
                                  }}
                                />
                                {meta.touched[field.inputName] &&
                                  meta.errors[field.inputName] ? (
                                  <div className="label-grid">
                                    <span />
                                    <span className="nodata">
                                      {meta.errors[field.inputName]}
                                    </span>
                                  </div>
                                ) : null}
                              </div>
                            );
                          } else if (field.dataType === "number") {
                            return (
                              <div className="label-grid" key={key}>
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  name={field.inputName}
                                  required={field.required}
                                  onKeyDown={handleFormEvent}
                                  maxLength={field.maxLength}
                                />
                                {meta.touched &&
                                  meta.errors[field.inputName] ? (
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                ) : null}
                              </div>
                            );
                          } else {
                            return (
                              <React.Fragment key={key}>
                                <InputHoc
                                  LabelName={field.labelName}
                                  values={formData[field.inputName]}
                                  name={field.inputName}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  required={field.required}
                                />
                                {meta.touched &&
                                  meta.errors[field.inputName] ? (
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                ) : null}
                              </React.Fragment>
                            );
                          }
                        }
                      )}
                      {formData.empType !== empType.SYS_ADMIN &&
                        formData.empType !== empType.TECHNICIAN &&
                        formData.empType !== empType.VENDOR_MANAGER &&
                        formData.empType !== empType.HELP_DESK &&
                        formData.empType !== empType.PMU ? (
                        <>
                          <div className="label-grid">
                            <Label>KGID </Label>
                            <InputNumber
                              value={formData.kgid}
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleValueChange(e, meta);
                              }}
                              onKeyDown={handleFormEvent}
                              name="kgid"
                              required
                            />
                            {meta.touched && meta.errors.kgid ? (
                              <span className="nodata">{meta.errors.kgid}</span>
                            ) : null}
                          </div>
                          <div className="label-grid">
                            <Label>Metal No</Label>
                            <InputNumber
                              value={formData.metalNo}
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleValueChange(e, meta);
                              }}
                              onKeyDown={handleFormEvent}
                              name="metalNo"
                              required
                            />
                            {meta.touched && meta.errors.metalNo ? (
                              <span className="nodata">
                                {meta.errors.metalNo}
                              </span>
                            ) : null}
                          </div>
                          <div className="label-grid">
                            <Label>{companyLabel} </Label>
                            <CompaniesAutocomplete
                              value={formData.companyID}
                              onChange={(newValue) => {
                                if (newValue)
                                  setFormData({
                                    ...formData,
                                    companyID: newValue.node.id,
                                  });
                                else
                                  setFormData({
                                    ...formData,
                                    companyID: 0,
                                  });
                              }}
                              onKeyDown={(e) => {
                                if (e.key === Keys.ENTER) {
                                  handleMUISelectEvent(e);
                                  e.preventDefault();
                                }
                              }}
                            />
                          </div>
                          <div className="label-grid">
                            <Label>{subsidiaryLabel} </Label>
                            <SubsidiarySelect
                              value={formData.subsidiaryID}
                              onChange={(newValue) => {
                                if (newValue)
                                  setFormData({
                                    ...formData,
                                    subsidiaryID: newValue.node.id,
                                  });
                                else
                                  setFormData({
                                    ...formData,
                                    subsidiaryID: 0,
                                  });
                              }}
                              onKeyDown={(e) => {
                                if (e.key === Keys.ENTER) {
                                  handleMUISelectEvent(e);
                                  e.preventDefault();
                                }
                              }}
                              companyID={formData.companyID}
                              label=""
                            />
                          </div>
                          <div className="label-grid">
                            <Label> {subsidiarySiteLabel}</Label>
                            <SiteSelect
                              label=""
                              onChange={(newValue) => {
                                if (newValue) {
                                  setFormData({
                                    ...formData,
                                    siteID: newValue.value,
                                  });
                                } else {
                                  setFormData({
                                    ...formData,
                                    siteID: 0,
                                  });
                                }
                              }}
                              companyId={
                                formData.companyID ? formData.companyID : 0
                              }
                              subsidiaryId={
                                formData.subsidiaryID
                                  ? formData.subsidiaryID
                                  : 0
                              }
                              onKeyDown={() => { }}
                              value={formData.siteID}
                            />
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                  <Button mode="save" type="submit" />
                  <Button mode="clear" type="reset" onClick={hanldeClear} />
                  <Button
                    mode="cancel"
                    onClick={() =>
                      setModalFlag({
                        flag: false,
                        operation: Operation.NONE,
                      })
                    }
                  />
                </Form>
              </div>
            </>
          );
        }}
      </Formik>
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal
        flag={
          GetEmpMasterByNodeIdLoading ||
          AddEmpMasterLoading ||
          UpdateEmpMasterLoading
        }
      />
    </>
  );
};

export default AddUsers;
